import { arrayOf } from 'prop-types';
import { categoryPreviewShape } from 'shapes';

const inCategorySearchShape = arrayOf(categoryPreviewShape);

export default inCategorySearchShape;
